module.exports = __webpack_public_path__ + "static/media/jawOpen.c4a31b30.obj";